module.exports = __webpack_public_path__ + "src/img/sigfloLogoWhite.f6ce70a6.svg";